import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Slide from "@mui/material/Slide";
import { bool, func, node } from "prop-types";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function CustomFullScreenDialog(props) {
  return (
    <Dialog
      open={props.open}
      TransitionComponent={Transition}
      keepMounted
      onClose={props.onClose}
      fullWidth={true}
      fullScreen
      maxWidth="md"
      scroll="paper"
      style={{ left: "50px" }}
    >
      <DialogTitle />
      <DialogActions disableSpacing>
        <IconButton onClick={props.onClose} color="primary" size="large">
          <CloseIcon />
        </IconButton>
      </DialogActions>
      <DialogContent>{props.children}</DialogContent>
    </Dialog>
  );
}

CustomFullScreenDialog.propTypes = {
  children: node,
  open: bool,
  onClose: func,
};
